import $ from "jquery";

$(function() {
    //Init popup event handlers
    $(".messagepopup .icon-closepopup").on("click", function() {
        const $messagepopup = $(this).closest(".messagepopup");
        $messagepopup.fadeOut(200);
    });
});

